import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '../../../icons/icon.component';

@Component({
  selector: 'app-dashboard-cards',
  imports: [CommonModule, IconComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './dashboard-cards.component.html'
})
export class DashboardCardsComponent {

  @Input() data: any = {};
  @Input() colSpan: number = 1;
  @Input() showComparisonValue: boolean = true;
  @Input() showPercentIcon: boolean = true;
  @Input() customClass: string = '';
  @Input() displayClass: 'flex' | 'flex-col' | 'block' = 'flex';
  @Input() iconClassType: 'flex' | 'flex-col' | 'inline-block' = 'inline-block';

  @Output() cardClick = new EventEmitter<void>();

  onClick() {
    this.cardClick.emit();
  }
}
